import { render, staticRenderFns } from "./ActionCardServiam.vue?vue&type=template&id=a99a3086&scoped=true&"
import script from "./ActionCardServiam.vue?vue&type=script&lang=js&"
export * from "./ActionCardServiam.vue?vue&type=script&lang=js&"
import style0 from "./ActionCardServiam.vue?vue&type=style&index=0&id=a99a3086&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99a3086",
  null
  
)

export default component.exports